import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { RouteService } from '../route.service'
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Union } from '../../agent/agent-interface.service';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-route-register',
  templateUrl: './route-register.component.html',
  styleUrls: ['./route-register.component.scss']
})
export class RouteRegisterComponent implements OnInit {

  route_register_form: FormGroup;
  action: string = '';
  unions: Union[] = [];
  sessions: Union[] = [];
  vehicles: any;
  constructor(private global: GlobalService ,private formBuilder: FormBuilder, private routeService : RouteService, private http: HttpService) {
    this.getUnions();
    this.getSession();
    this.getVehicle();
    this.route_register_form = this.formBuilder.group({
      id: [null, Validators.compose([])],
      name: [null, Validators.compose([Validators.required])],
      union_id: [null, Validators.compose([Validators.required])],
      session_id: [null, Validators.compose([Validators.required])],
      order_expiry_time: [null, Validators.compose([Validators.required])],
      vehicle_id:  [null, Validators.compose([Validators.required])],
      departure_time: [null, Validators.compose([Validators.required])],
    })

    if (this.routeService.get_route_data === null) {
      this.action = 'register';
    } else {
      this.action = 'update';
      this.setupUpdateForm(this.routeService.get_route_data);
    }

    this.routeService.RouteUpdate.subscribe((relation_data) => {
      if (relation_data === null) {
        this.action = 'register';
        this.route_register_form.reset();
      } else {
        this.action = 'update';
        this.setupUpdateForm(relation_data);
      }
    });

    this.routeService.RouteUpdate.subscribe((relation_type) => {
      this.setupUpdateForm(relation_type);
    });
  }

  onChange() {
    const vehicle_id = this.route_register_form.value['vehicle_id']
    const route_id = this.route_register_form.value['id']
    console.log(vehicle_id)
    const data_dict = {
      'vehicle_id':vehicle_id,
      'route_id':route_id,
      'session_id':this.route_register_form.value.session_id
    }
    this.http.checkVehicleAssignedToAnotherRoute(data_dict).subscribe((data: string)=> {
      console.log(data);
      if (confirm(data)) {
        this.registerRoute();
      }
    })
  }


  getUnions() {
    this.http.getUnions().subscribe((data: Union[]) => {
      console.log(data);
      this.unions = data;
    }, (error) => {
      console.log(error);
    });
  }


  getSession() {
    this.http.getSessions().subscribe((data: Union[]) => {
      console.log(data);
      this.sessions = data;
    }, (error) => {
      console.log(error);
    });
  }

  setupUpdateForm(data) {
    this.route_register_form.controls['id'].setValue(data['id']);
    this.route_register_form.controls['name'].setValue(data['name']);
    this.route_register_form.controls['union_id'].setValue(data['union_id']);
    this.route_register_form.controls['session_id'].setValue(data['session_id']);
    this.route_register_form.controls['order_expiry_time'].setValue(data['order_expiry_time']);
    this.route_register_form.controls['vehicle_id'].setValue(data['vehicle_id']);
    this.route_register_form.controls['departure_time'].setValue(data['departure_time']);

   }

   registerRoute() {
    const route_data = Object.assign({}, this.route_register_form.value);
    console.log(route_data)
    this.http.registerRoute(route_data).subscribe((data) => {
      this.global.showSnakeBar(data['message']);
      this.route_register_form.reset();
      this.routeService.downloadRoute.emit(true);
      this.routeService.is_display_route_register_component = false;
    },(error)=> {
      console.log(error);
      this.global.showErrorSnakeBar(error['error']['message'])
    });
  }

  getVehicle() {
    this.http.getVehicle().subscribe((data: VEHICLE[]) => {
      console.log(data);
      this.vehicles = data;
    }, (error) => {
      console.log(error);
    });
  }


  ngOnInit() {
  }

}
export interface VEHICLE {
  id: number;
  name: string;
}
